import { render } from "./OrganizationList.vue?vue&type=template&id=4ddc6c0a&scoped=true"
import script from "./OrganizationList.vue?vue&type=script&lang=js"
export * from "./OrganizationList.vue?vue&type=script&lang=js"

import "./OrganizationList.vue?vue&type=style&index=0&id=4ddc6c0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddc6c0a"]])

export default __exports__